import { QA_API_DOMAIN, fetchWithSupabaseAuth } from "@/api/classifier";
import { useState } from "react";

export function useProcessEncounter() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const processEncounter = async (encounterId: string) => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await fetchWithSupabaseAuth(`${QA_API_DOMAIN}/encounters/encounters/process`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ encounterId }),
      });
      if (!res.ok) {
        const errorData = await res.json().catch(() => null);
        throw new Error(errorData?.error || errorData?.message || `HTTP ${res.status}`);
      }
      const data = await res.json();
      return data;
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : "Unknown error";
      setError(errorMessage);
      throw e;
    } finally {
      setIsLoading(false);
    }
  };

  return { processEncounter, isLoading, error };
}
